export default __webpack_public_path__ + "static/char-30-anr-4b30eb55880767f76fb5cfe20e454a8d.gif";